import Modal from 'react-bootstrap/Modal';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import classes from "./maintainerStyles.module.scss"
import { ClientTypes, OrgIdContext,CustomerRelations } from "../../store/orgId_context";
import { useContext, useEffect, useRef, useState } from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container, Row, Col } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { Checkbox, FormControlLabel} from '@mui/material';
import Button from '../UI/Button';
import { useSearchParams } from 'react-router-dom';

const SetUserRolesModal = ({onHide,show, ...props}) =>{
    const { sessionInfo, isTransformer, isIntegrator,isBuilder, clientType, ISVCustomer, AccCustomer,customerRelation,isTrustee, domain } = useContext(OrgIdContext);
    const [searchParam, setSearchParam] = useSearchParams();
    /* 
    if(searchParams.has("IsTransformer"))
      setIsTransformerHandler(searchParams.get("IsTransformer")==="false" ? false : true);
    if(searchParams.has("IsIntegrator"))
      setIsIntegratorHandler(searchParams.get("IsIntegrator")==="false" ? false : true);
    if(searchParams.has("IsBuilder"))
      setIsBuilderHandler(searchParams.get("IsBuilder")==="false" ? false : true);
    if(searchParams.has("ClientType"))
      setClientTypeHandler(searchParams.get("ClientType"));
    if(searchParams.has("ISVCustomer"))
      setISVCustomerHandler(searchParams.get("ISVCustomer"));
    if(searchParams.has("AccSCustomer"))
      setAccCustomerHandler(searchParams.get("AccSCustomer"));
    if(searchParams.has("CustomerRelation"))
      setCustomerRelationHandler(searchParams.get("CustomerRelation"));
    if(searchParams.has("Trustee"))
      setCustomerRelationHandler(searchParams.get("Trustee")==="false" ? false : true);*/
    
    const { handleSubmit, register, formState: { errors }, control, setValue } = useForm({
        defaultValues: {
            "IsTransformer" : isTransformer,
            "IsIntegrator" : isIntegrator,
            "IsBuilder" : isBuilder,
            "ClientType" : clientType ===null ? "EndClient" : clientType,
            "ISVCustomer" : ISVCustomer,
            "AccSCustomer" : AccCustomer,
            "CustomerRelation" : customerRelation,
            "Trustee" : isTrustee,
            "Domain" : domain
        },
    });

    useEffect(() =>{
        if(show){
            setValue("IsTransformer",isTransformer);
            setValue("IsIntegrator",isIntegrator);
            setValue("IsBuilder",isBuilder);
            setValue("ClientType",clientType ===null ? "EndClient" : clientType);
            setValue("ISVCustomer",ISVCustomer);
            setValue("AccSCustomer",AccCustomer);
            setValue("CustomerRelation",customerRelation ===null ? "None" : customerRelation);
            setValue("Trustee",isTrustee);
            setValue("Domain", domain)
        }
    },[show]);
    

    const onSubmit = (data) =>{
        let append = [];
        for(const key in data){
            if(key === "CustomerRelation" || key ==="ClientType" || key==="Domain"){
                if(!data[key] || data[key] === "")
                    continue;
                append.push(encodeURIComponent(key)+"=" + encodeURIComponent(data[key]))
            }else{
                if(data[key] !== null)
                    append.push(encodeURIComponent(key)+"=" + encodeURIComponent(data[key]))
            }
        }
        window.location.replace("http://"+window.location.host+"/dashboard?"+append.join("&"))
    }

    const reloadPage = (e) =>{
        e.preventDefault();
        //window.location.href = "http://"+window.location.host+"/dashboard?aa=1";
        window.location.replace("http://"+window.location.host+"/dashboard")
    }

    return (<Modal
        {...props}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className={classes.modalHeader}>
          <div className='w-100 d-flex '>
              <div>
                <SupervisedUserCircleIcon style={{fontSize:"2.2rem", marginRight:"1rem"}}/>
                <span className={classes.modalTitleText}>Fake user roles</span>
              </div>
              <div className="ms-auto">
                <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}} onClick={onHide}/>
              </div>
            </div>
        </Modal.Header>
        <Modal.Body className={classes.modalBody} style={{height:"30vh"}}>
            <Container>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* <Row>
                        <Col><label htmlFor="name2">Name*</label></Col>
                        <Col><input
                                type="text"
                                name="Name2"
                                id="name2"
                                {...register("Name2")}
                                placeholder="Name of the business"
                            /></Col>
                    </Row> */}
                    <div className={classes["container-form"]}>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="Domain">Domain</label>
                            <Controller
                            name="Domain"
                            id="Domain"
                            control={control}
                            render={({ field }) => {
                                return (
                                <select {...field} onChange={(e) =>{
                                    //onCountryChange(e);
                                    field.onChange(e);
                                }}>
                                    <option value="" key="none"></option>
                                    <option value="DDDInvoices" key="DDDInvoices">DDDInvoices</option>
                                    <option value="EInvoices" key="EInvoices">EInvoices</option>
                                </select>
                                );
                            }}
                            />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="ClientType">Client type</label>
                            <Controller
                            // type="text"
                            name="ClientType"
                            id="ClientType"
                            control={control}
                            render={({ field }) => {
                                return (
                                <select {...field} onChange={(e) =>{
                                    //onCountryChange(e);
                                    field.onChange(e);
                                }}>
                                    <option value="" key="none"></option>
                                    <option value="EndClient" key="null">null</option>
                                    <option value="ISV" key="ISV">ISV</option>
                                    <option value="Company" key="Company">Company</option>
                                    <option value="AccService" key="AccService">AccService</option>
                                    <option value="Enterprise" key="Enterprise">Enterprise</option>
                                </select>
                                );
                            }}
                            />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="IsTransformer">Is transfomer</label>
                            <Controller
                            name={"IsTransformer"}
                            
                            control={control}
                            render={({ field: props }) =>{return (
                            <Checkbox
                                {...props}
                                indeterminate ={props.value===null}
                                checked={props.value}
                                onChange={(e) => props.onChange(e.target.checked)}
                            />
                            )}}
                        />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="IsIntegrator">Is integrator</label>
                            <Controller
                            name={"IsIntegrator"}
                            control={control}
                            render={({ field: props }) => (
                            <Checkbox
                                {...props}
                                indeterminate ={props.value===null}
                                checked={props.value}
                                onChange={(e) => props.onChange(e.target.checked)}
                            />
                            )}
                        />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="IsBuilder">Is builder</label>
                            <Controller
                            name={"IsBuilder"}
                            control={control}
                            render={({ field: props }) => (
                            <Checkbox
                                {...props}
                                indeterminate ={props.value===null}
                                checked={props.value}
                                onChange={(e) => props.onChange(e.target.checked)}
                            />
                            )}
                        />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="ISVCustomer">ISV Customer</label>
                            <Controller
                            name={"ISVCustomer"}
                            control={control}
                            render={({ field: props }) => (
                            <Checkbox
                                {...props}
                                indeterminate ={props.value===null}
                                checked={props.value}
                                onChange={(e) => props.onChange(e.target.checked)}
                            />
                            )}
                        />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="AccSCustomer">AccSCustomer</label>
                            <Controller
                            name={"AccSCustomer"}
                            control={control}
                            render={({ field: props }) => (
                            <Checkbox
                                {...props}
                                indeterminate ={props.value===null}
                                checked={props.value}
                                onChange={(e) => props.onChange(e.target.checked)}
                            />
                            )}
                        />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="Trustee">Trustee</label>
                            <Controller
                            name={"Trustee"}
                            control={control}
                            render={({ field: props }) => (
                            <Checkbox
                                {...props}
                                indeterminate ={props.value===null}
                                checked={props.value}
                                onChange={(e) => props.onChange(e.target.checked)}
                            />
                            )}
                        />
                        </fieldset>
                        <fieldset className={classes["input-container"]}>
                            <label htmlFor="CustomerRelation">Customer relation</label>
                            <Controller
                            // type="text"
                            name="CustomerRelation"
                            id="CustomerRelation"
                            control={control}
                            render={({ field }) => {
                                return (
                                <select {...field} onChange={(e) =>{
                                    //onCountryChange(e);
                                    field.onChange(e);
                                }}>
                                    <option value="" key="none"></option>
                                    <option value="None" key="null">null</option>
                                    <option value="AdminByCustomer" key="AdminByCustomer">AdminByCustomer</option>
                                    <option value="SupportByDDD" key="SupportByDDD">SupportByDDD</option>
                                    <option value="EIOL" key="EIOL">EIOL</option>
                                </select>
                                );
                            }}
                            />
                        </fieldset>
                    </div>
                    <div>
                    <Button type="submit" className="px-5 py-1 ms-3">
                        Load
                    </Button>
                    <Button onClick={reloadPage} className="px-5 py-1 ms-3">
                        Clear
                    </Button>
                    </div>
                </form>
            </Container>
        </Modal.Body>
      </Modal>)
}
export default SetUserRolesModal;